import { Tabs as BaseTabs } from "@base-ui/react/tabs";
import type { ReactNode } from "react";
import { cx } from "./cx.js";

export interface TabItem {
  value: string;
  label: ReactNode;
  content: ReactNode;
}

/** Base UI Tabs as a segmented control over their panels; the first tab is open unless `defaultValue` says otherwise. */
export function Tabs({ items, defaultValue, className }: { items: TabItem[]; defaultValue?: string; className?: string }) {
  return (
    <BaseTabs.Root className={cx("dt-tabs", className)} defaultValue={defaultValue ?? items[0]?.value}>
      <BaseTabs.List className="dt-tabs__list">
        {items.map((item) => (
          <BaseTabs.Tab key={item.value} value={item.value} className="dt-tabs__tab">
            {item.label}
          </BaseTabs.Tab>
        ))}
      </BaseTabs.List>
      {items.map((item) => (
        <BaseTabs.Panel key={item.value} value={item.value} className="dt-tabs__panel">
          {item.content}
        </BaseTabs.Panel>
      ))}
    </BaseTabs.Root>
  );
}
